export enum PaginationAction {
  NEXT_PAGE = 'NEXT_PAGE',
  PREV_PAGE = 'PREV_PAGE',
  FIRST_PAGE = 'FIRST_PAGE',
  LAST_PAGE = 'LAST_PAGE',
}
